import { render, staticRenderFns } from "./page_new_ar.vue?vue&type=template&id=7daf543b&scoped=true&"
import script from "./page_new_ar.vue?vue&type=script&lang=js&"
export * from "./page_new_ar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7daf543b",
  null
  
)

export default component.exports